import React from 'react';
import { Forms, SystemText } from '@salesperformanceint/e4shared';

const Search = ({ runSearch, defaultSearch, competencies, defaultCompetencyIds }) => {
    const [search, setSearch] = React.useState(defaultSearch);
    const [competencyIds, setCompetencyIds] = React.useState(defaultCompetencyIds);

    return (
        <div className="mb10">
            <div>
                <Forms.Text
                    id="filter-search"
                    label={SystemText('Admin/Forms/FilePicker/Showpad/Search/Label')}
                    help={SystemText('Admin/Forms/FilePicker/Showpad/Search/Help')}
                    placeholder={SystemText('Admin/Forms/FilePicker/Showpad/Search/Placeholder')}
                    value={search}
                    onChange={x => setSearch(x)}
                    onSubmit={() => runSearch(search, competencyIds)}
                    data-testid="text-search-showpad"
                    icon="fa-search"
                />
                <Forms.Select
                    label={null}
                    data={competencies || []}
                    allowMultiple
                    value={competencyIds}
                    onChange={setCompetencyIds}
                    data-testid="select-search-showpad"
                />
            </div>
            <div className="mb10">
                <button
                    data-testid="button-search-showpad"
                    id="search-button"
                    className="btn btn-primary"
                    onClick={() => runSearch(search, competencyIds)}
                >
                    {SystemText('Admin/Forms/FilePicker/Showpad/Button/Search')}
                </button>
            </div>
        </div>
    );
};

export default Search;
